export default {
  methods: {
    handleInput(e) {
      e.target.value = e.target.value.toLowerCase();
    },
  },
};
